import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DigitalMarketingComponent } from './components/pages/digital-marketing/digital-marketing.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ServiceDetailsComponent } from './components/pages/service-details/service-details.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';


const routes: Routes = [
    {path: '', component: DigitalMarketingComponent},
    { path: 'about', component: AboutComponent},
    { path: 'service-details', component: ServiceDetailsComponent},
    {path:'pricing',component:PricingComponent},
    { path: '**', component: NotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
